const zhCN = {
  common: {
    freeTrial: "立享30天免费使用",
    labelSeparator: "：",
    parenthesized: "（{{value}}）",
  },
  header: {
    home: "首页",
    shoprise: "Shoprise有品",
    features: "特性展示",
    productFeatures: "功能特性",
    theme: "模板展示",
    pricing: "套餐定价",
    advertising: "推广服务",
    support: "服务支持",
    question: "常见问题",
    about: "关于我们",
    aboutus: "公司介绍",
    partner: "合作伙伴",
  },
  footer: {
    product: "产品介绍",
    service: "服务",
    company: "公司",
    agreement: "用户协议",
    terms: "服务条款",
    privacy: "隐私政策",
    location: "中国 成都",
    language: "语言",
    languageSelector: "选择语言",
    chinese: "简体中文",
    english: "English",
  },
  home: {
    title: "首页-Shoprise 官网",
    cta: "现在就去",
    intro: {
      build: {
        title: "建站，从未如此轻松",
        details: [
          "卡片式装修，眼见即所得",
          "店铺风格一键切换，常新方能常青",
          "30款精美模板，每一款都匠心独运",
          "只需30分钟，专属独立站即刻拥有",
        ],
      },
      product: {
        title: "商品上新，从未如此简单",
        details: [
          "专业一键导品工具，您看上的，我们帮您拿下",
          "独家选品工具，卖什么最赚钱我们最了解",
          "按需打印（POD）不可或缺，我们有最棒的体验和素材",
          "商品全属性批量管理，解放您的时间",
        ],
      },
      marketing: {
        title: "营销，从未如此高效",
        details: [
          "优惠码、满送优惠、自动优惠、组合优惠……比您预期的稍多一点",
          "搜索引擎优化、Google追踪、FB像素……全方位获取自然流量",
          "Google Ads、Twitter Ads、FB Ads……助力引爆社交平台",
          "会员系统、弃单召回、自定义邮件……打造您的专属私域流量池",
        ],
      },
    },
    iconGroup: {
      title: "管理，从未如此得心应手",
      items: [
        "多语言",
        "多货币",
        "实时物流",
        "安全支付",
        "数据报表",
        "员工权限管理",
        "要素聚合呈现",
        "税费自动结算",
      ],
    },
    advantage: {
      title: "优势，人无我有",
      items: [
        {
          title: "亚马逊全球云服务器",
          detail:
            "我们使用全球最快、最稳定的亚马逊全球云服务器集群，拥有最好的速度和性能，自动监控扩容，24小时巡检保障业务稳定",
        },
        {
          title: "智能选品工具",
          detail:
            "我们拥有市面上最强大的选品工具，最多的搜索维度，最全面的数据结果，让您一搜就知当前最棒的卖品是什么，时刻掌握市场动态，永远快人一步",
        },
        {
          title: "Facebook广告助手",
          detail:
            "我们拥有市面上最准确的广告归因工具，助力精准评判每条投放渠道带给广告主的线索量和转化率，帮助广告主识别每条渠道的用户特征，便于有针对性地进行业务策略调整",
        },
      ],
    },
    ecological: {
      title: "生态，人有我优",
      items: [
        {
          title: "ERP",
          details: [
            "智能化产品库，订单自动处理，高效发货",
            "多维可视化数据分析，掌握实时店铺数据",
            "跨平台产品采集，全流程数据化管理",
          ],
        },
        {
          title: "支付",
          details: [
            "支持PayPal、信用卡等多种方式支付",
            "打通主流收款方式，支持多币种",
            "结算超低汇率、超快到账、稳定安全",
          ],
        },
        {
          title: "运营",
          details: [
            "业内一流运营团队指导",
            "私域流量池沉淀接入",
            "Google Merchant Center，轻松获取天然流量",
          ],
        },
      ],
    },
    platform: {
      title: "汇聚海外流量",
      subtitle: "专业顾问，高效开户",
      items: [
        ["全球27亿用户"],
        ["每人每天", "搜索10次"],
        ["每日浏览", "10亿次"],
        ["每月搜索", "10亿次"],
      ],
    },
    serviceGroup: {
      title: "业界一流团队为您服务",
      items: [
        {
          title: "专业营销团队",
          details: ["海外市场营销专家", "助力中国品牌走向世界"],
        },
        {
          title: "专业技术团队",
          details: ["专业化技术支持", "提供全球化", "安全稳定的系统"],
        },
        {
          title: "专业咨询服务",
          details: ["小白无忧一对一教学", "助力独立站业务启航"],
        },
        {
          title: "专业售后团队",
          details: ["7*24小时在线客服", "无论何时何地", "我们都在您身边"],
        },
      ],
    },
    partner: {
      title: "合作伙伴",
      seeMore: "查看更多>>",
    },
  },
  register: {
    title: "用户注册-Shoprise 官网",
    formTitle: "开始免费试用",
    email: "邮箱",
    emailRequired: "请输入邮箱",
    emailInvalid: "邮件格式错误",
    password: "密码",
    passwordRequired: "请输入密码",
    passwordHelp: "6-20位英文、数字和字符组合",
    code: "验证码",
    codeRequired: "请输入6位数字验证码",
    sendCode: "发送验证",
    resendCode: "重新发送({{restTime}})",
    acceptPrefix: "我接受",
    agreement: "《用户协议》",
    terms: "《服务条款》",
    privacy: "《隐私政策》",
    submit: "注册",
    introLines: [
      "数十种免费店铺主题模板，",
      "整合智能选品、自动化管理、精准广告归因等工具于一体，",
      "一站式满足店铺管理及推广需求。",
    ],
  },
  information: {
    title: "用户信息收集-Shoprise 官网",
    cardTitle: "设置企业信息",
    companyStep: "1/企业信息",
    contactStep: "2/联系人信息",
    companyExtra: "我们将根据您的企业信息推荐最佳方案",
    contactExtra: "我们将向联系人发送审核信息",
    addressLabel: "企业地址",
    countryChina: "中国",
    addressPlaceholder: "请输入详细地址",
    salesLabel: "您每年的销售额是？",
    goodsTypeLabel: "您销售的商品类目是？",
    next: "下一步",
    contactNameLabel: "联系人姓名",
    contactNameRequired: "请输入联系人姓名",
    contactNamePlaceholder: "请输入联系人姓名",
    phoneLabel: "联系号码",
    phoneInvalid: "请输入正确的电话号码",
    phoneRequired: "请输入电话号码",
    phonePlaceholder: "请输入联系人手机号码",
    previous: "返回上一步",
    submit: "提交",
    successTitle: "提交成功",
    successDescription: "感谢您申请注册，我们已收到您的资料。",
    successNotice: "申请结果将在近期通过手机短信/邮件进行通知，请注意查看。",
    backHome: "返回首页",
    yearTurnoverOptions: [
      " 0-99万人民币",
      "100-499万人民币",
      "500-999万人民币",
      "1000-4999万人民币",
      "5000万人民币以上",
    ],
    goodsTypeOptions: [
      "代工厂",
      "自有品牌",
      "货铺",
      "无资源(一键代发)",
      "其他",
    ],
    administrativeArea: "行政区划 {{code}}",
    locationLabels: {
      北京市: "北京市",
      天津市: "天津市",
      河北省: "河北省",
      山西省: "山西省",
      内蒙古自治区: "内蒙古自治区",
      辽宁省: "辽宁省",
      吉林省: "吉林省",
      黑龙江省: "黑龙江省",
      上海市: "上海市",
      江苏省: "江苏省",
      浙江省: "浙江省",
      安徽省: "安徽省",
      福建省: "福建省",
      江西省: "江西省",
      山东省: "山东省",
      河南省: "河南省",
      湖北省: "湖北省",
      湖南省: "湖南省",
      广东省: "广东省",
      广西壮族自治区: "广西壮族自治区",
      海南省: "海南省",
      重庆市: "重庆市",
      四川省: "四川省",
      贵州省: "贵州省",
      云南省: "云南省",
      西藏自治区: "西藏自治区",
      陕西省: "陕西省",
      甘肃省: "甘肃省",
      青海省: "青海省",
      宁夏回族自治区: "宁夏回族自治区",
      新疆维吾尔自治区: "新疆维吾尔自治区",
      台湾省: "台湾省",
      香港特别行政区: "香港特别行政区",
      澳门特别行政区: "澳门特别行政区",
      东城区: "东城区",
      西城区: "西城区",
      朝阳区: "朝阳区",
      丰台区: "丰台区",
      石景山区: "石景山区",
      海淀区: "海淀区",
      门头沟区: "门头沟区",
      房山区: "房山区",
      通州区: "通州区",
      顺义区: "顺义区",
      昌平区: "昌平区",
      大兴区: "大兴区",
      怀柔区: "怀柔区",
      平谷区: "平谷区",
      密云区: "密云区",
      延庆区: "延庆区",
    },
  },
  themePage: {
    title: "模板展示-Shoprise 官网",
    cta: "准备好被自己惊艳了吗",
    templateNames: [
      "首饰模板",
      "家居模板",
      "鞋类模板",
      "彩妆模板",
      "配饰模板",
      "女装模板",
    ],
  },
  questionPage: {
    title: "常见问题-Shoprise 官网",
    banner: "Shoprise 常见问题",
    items: [
      {
        question: "如何操作升级套餐？",
        answer:
          "我们支持采用补差价的方式升级套餐。 如果您有升级的需求，可以登陆商家后台，点击右上角头像，点击“订阅管理”-“本期订阅”-“操作”，选择“升级套餐”进行升级。 您需要支付的费用为新套餐的价格减去基于老版本套餐剩余时间折算后的价格。",
      },
      {
        question: "Shoprise是否支持绑定自己的域名？",
        answer:
          "支持。如果您已经购买了相关域名，您可以直接将购买的域名绑定到Shoprise店铺。在网站管理后台首页的“个性化独立站域名”模块即可完成域名绑定。 同时，针对每一个商店，Shoprise的后台都会自动生成一个域名，供您免费使用。",
      },
      {
        question: "注册店铺后不会操作该怎么办？",
        answer:
          "Shoprise的后台操作十分简单，按照我们的提示，您可以在 30 分钟内轻松完成网站搭建。并且在您购买套餐后，我们将为您提供“小白无忧“1对1的专业服务来确保您正确快捷地上手业务。",
      },
      {
        question: "Shoprise所提供的模板需要收费吗？",
        answer:
          "不需要，使用Shoprise后台提供的任何模版，您都无需额外支付费用。Shoprise团队会定期更新行业模版，您可以根据您的需求选择最适合的模版设计。",
      },
      {
        question: "我需要为所使用的带宽付费吗？",
        answer:
          "不需要，使用Shoprise，您无需额外支付带宽费用。所有套餐都支持无限带宽使用。",
      },
      {
        question: "创建独立站要收费吗？",
        answer:
          "免费，创建独立站是我们的免费服务，我们的收费服务是协助您进行店铺运营管理以及将您的生意推广至全球。",
      },
      {
        question: "我要输入信用卡信息才能注册账户吗？",
        answer:
          "不需要。新用户有30天免费试用Shoprise的机会，且无需输入信用卡信息。试用期结束后，如果您想正式开店营业，则需要选择一个每月维护方案，再输入相关信用卡信息。",
      },
      {
        question: "我可以随时注销账号吗？",
        answer:
          "当然可以。如果您认为不再需要使用当前的服务，可以随时注销账号，这不会给您带来任何的后顾之忧。",
      },
      {
        question: "你们支付方案的合同有效期是多久？",
        answer: "所有Shoprise价格方案均按月计费。",
      },
      {
        question: "Shoprise是否 PCI 合规或拥有 PCI 认证？",
        answer:
          "是的，Shoprise拥有支付卡行业数据安全一级标准 (PCI DSS) 认证。这意味着您所有的数据和客户信息在我们这里都将完全保密。",
      },
      {
        question: "我必须在实体店和独立站销售一样的产品吗？",
        answer:
          "不用，您可以将独立站理解为您的另一个店铺，它们可以卖相同的产品，也可以卖不同的产品，只要您愿意，您可以自行决定在实体店和独立站销售的产品。",
      },
      {
        question: "交易产生任何手续费吗？",
        answer:
          "如果您选择使用外部支付网关，Shoprise Essentials用户需额外支付2%交易费，Shoprise Standard用户支付1%交易费，Shoprise Premium用户的交易费需要通过咨询议价。 ",
      },
      {
        question: "我可以在 Shoprise使用第三方支付平台吗？",
        answer:
          "可以，Shoprise支持使用多种第三方支付平台，以此确保您的生意能够平稳进行。 ",
      },
      {
        question: "我需要自己购买服务器吗？",
        answer:
          "Shoprise的所有价格方案都已包含由全球顶尖的电商服务器提供的服务，我们将通过网络来为您提供相应的业务赋能，您只需要使用这种服务即可，不需要额外添加任何的设备。 ",
      },
    ],
  },
  partnerPage: {
    title: "合作伙伴-Shoprise 官网",
    heading: "合作伙伴",
    subheading: "Partner",
    sections: ["战略合作伙伴", "支付合作伙伴", "ERP合作伙伴"],
    cta: "立即免费使用30天",
  },
  aboutPage: {
    title: "关于我们-Shoprise 官网",
    banner: "我们全力以赴，只为合作共赢",
    aboutTitle: "关于Shoprise",
    intro: [
      "Shoprise是成都泛兮科技精心打造的独立站建站SaaS服务系统，在中国电商独立站出海潮的时代大背景下，立足于中国卖家的核心需求，着眼于海外市场的风云变幻，乘中国制造体系、商务模式成熟双红利之东风，积极帮助中国卖家抢占海外市场，与用户时刻保持沟通，认真聆听用户的声音，快速迭代满足用户的真切需求。Shoprise成立之初便确定了自身的使命所在——赋能出海电子商务，助力中国制造拥抱全球市场。",
      "我们的团队横跨多个城市，拥有强大的支撑能力与广阔的商业格局。其中，出海业务团队是跨境电商SaaS建站行业里老牌的服务提供商，其研发的SaaS系统从一开始就采用了全球最顶级的亚马逊服务器集群作为物理基础，采用的系统技术架构先进且稳定，具备强大的伸缩能力和容灾能力，自运行以来所建造的网站可用性无限趋近于100%，确保商户的交易始终稳定、安全地进行。",
      "当前，前后十年是出海独立站急速扩张的十年，这是出海独立站的黄金时代，我们将秉承初心，全力协助中国制造拥抱全球，创造更多属于我们自己的品牌，真正做到“立足中国，拥抱世界”！",
    ],
    contactTitle: "联系我们",
    emailLabel: "公司邮箱",
    addressLabel: "公司地址",
    address: "中国（四川）自由贸易试验区成都高新区吉泰五路88号3栋11层1号",
    consultTimeLabel: "咨询时间",
    consultTime: "周一至周五，9:00AM-6:00PM",
    cta: "立享30天免费使用",
  },
  shoprisePage: {
    title: "shoprise有品-Shoprise 官网",
    heading: "Shoprise有品",
    subheading: "昨日TOP40商品&广告",
    imageAlt: "商品图片",
    productCategory: "产品分类",
    startDate: "最近启投时间",
    weight: "投放权重",
    pageLike: "Page Like",
    copyInfo: "文案信息",
    viewVideo: "查看视频",
    viewAd: "查看广告",
    storeAd: "店铺广告",
    trendTitle: "广告投放趋势图",
    deliveryCount: "投放数",
    loadMore: "加载更多",
    exploreMore: "探索更多信息",
    footerCta: "立即探索更多",
    noDataHeading: "Shoprises有品",
    noDataText: "商品广告数据跑丢了，请刷新试试",
    noDataDescription: [
      "Shoprise有品是跨境电商行业内最强大的数据选品工具，每日更新当前市面上最热门的商品及其广告数据。",
      "支持多达20个维度筛选商品，包括产品IP、语种、分析模型、广告类型等独有维度；",
      "支持Apple app / Facebook app / Google app / Magento / Opencart / Shopify / Zencart等主流平台定向筛选；",
      "支持Facebook / Instagram / Audience network / Messenger等主流广告平台定向筛选。",
    ],
    noDataList: [
      "●Shoprise的广告投放趋势可以评估商品热度，适合独立站打造爆款商品的跨境电商卖家",
      "●Shoprise可以通过关键词搜索来筛选广告数据，适用于希望通过差异化销售获取新客户的跨境电商卖家",
      "●Shoprise支持显示多个广告平台和电商平台的广告数据，适用于希望扩大信息源来寻找选品灵感的跨境电商卖家",
      "●Shoprise为跨境电商卖家商品测款时提供辅助服务",
      "●Shoprise提供多种精细商品的广告数据，适合于实时进行高效、轻松选品的跨境电商卖家",
    ],
  },
  helpCenterPage: {
    title: "帮助中心-Shoprise 官网",
    searchPlaceholder: "输入关键词以搜索",
    groups: [
      {
        title: "快速搭建店铺",
        items: ["店铺装修", "新增商品", "物流设置", "结账设置"],
      },
      {
        title: "促销方案",
        items: ["优惠码", "自动优惠", "梯度优惠", "满送优惠"],
      },
      {
        title: "数据运营",
        items: ["数据分析", "实时视图", "销售报告", "广告助手"],
      },
      {
        title: "店铺管理",
        items: ["客户管理", "订单管理", "店铺设置", "员工权限"],
      },
      {
        title: "生态应用",
        items: ["数据跟踪", "运营工具", "效率工具", "广告投放"],
      },
    ],
  },
  advertisingPage: {
    title: "推广服务-Shoprise 官网",
    facebookService: "Facebook推广服务",
    googleService: "Google推广服务",
    bingNetwork: "必应广告网络遍布全球",
    searchMarketShare: "搜索市场份额",
    monthlySearch: "月度搜索",
    ourService: "我们的服务",
    serviceSubtitle: "全流程/全方位/全心全意",
    facebookData1: [
      { data: { main: "43.82", extra: "%" }, details: "针对Niche市场的锁定精准程度" },
      { data: { main: "1/3", extra: "" }, details: "全球1/3人口真实身份/真实位置/真实爱好" },
      { data: { main: "20亿", extra: "+" }, details: "每月20亿+活跃账号" },
    ],
    facebookData2: [
      { title: "创建Facebook主页", details: "主页是Facebook用户认识您的窗口，也是您展示自家品牌形象的舞台，帮助您与潜在受众建立联系，推广业务" },
      { title: "开通Facebook广告账户", details: "Facebook委托国内广告代理商及经销商为中国出海广告商提供一系列专业服务和协助" },
      { title: "定位目标受众", details: "根据尼尔森线上营销活动评估，Facebook的精确度是其他广告网络的2倍以上" },
      { title: "确定推广目标", details: "Facebook有13 种不同的广告目标。对于经营电商广告商来说，增加网站转换量、吸引更多网站访客是首选的广告目标" },
      { title: "创建Facebook广告", details: "Facebook广告由 3 部分组成：广告系列、广告组和广告。创建广告时，始终以创建广告系列开始" },
      { title: "选择广告创意", details: "Facebook拥有视频广告、幻灯片广告、链接式广告、轮播广告、360全景广告、Instagram快拍广告等广告创意" },
      { title: "Messenger", details: "Messenger方便商家轻松与用户建立直接联系。还可以设置自动回复以及创建 Messenger 智能助手" },
      { title: "效果评估", details: "通过Facebook监控工具，帮助您了解广告效果，方便让您及时调整广告策略，改善广告效果" },
    ],
    googleData1: [
      { title: "精准定位目标客户", details: "通过定位地理位置、语言、展示位置、设备和受众群体等，准确的找到你想要的客户" },
      { title: "免费展示广告信息", details: "仅在潜在客户点击广告访问你的网站时才收费，如潜在客户看到广告但没有点击则不收费，也就是免费展示广告信息" },
      { title: "搜索引擎市场份额全球第一", details: "全球搜索引擎市场份额Google占比92.6%，是第二名的45倍" },
    ],
    googleData2: [
      { title: "关键词", details: "更全面的关键词覆盖，细致入微的匹配设置，让您的每一分钱都出效果" },
      { title: "创意文案", details: "我们提供优秀的海外创意文案，让您的广告效果卓尔不群" },
      { title: "服务", details: "我们团队提供多对一的专业服务，想您所想，卡点问题全力解决" },
      { title: "分析报告", details: "每周为您提供上周总结报告，每月月度总结让您轻松掌控账户情况" },
      { title: "二次营销", details: "私域运营为您不断降低获客成本，促使客户进行购买，提高转化率" },
    ],
    bingData1: [
      { title: "高购买力用户", details: "比平均联网用户高101%，比Google高40%" },
      { title: "覆盖多个平台和终端", details: "办公or娱乐，PC/平板/手机，全方位全场景广告完美注入" },
      { title: "定位精确", details: "可根据设备、地域、时间等进行定向广告，精准锁定目标用户" },
    ],
    bingData2: [
      { head: "全球", percentage: "10%", data: "110亿" },
      { head: "北美", percentage: "34%", data: "62.8亿" },
      { head: "欧洲", percentage: "9%", data: "20亿" },
      { head: "亚太地区", percentage: "4%", data: "20亿" },
      { head: "拉美", percentage: "6%", data: "7.41亿" },
    ],
    ourServiceData: [
      { title: "免费广告开户", details: "免费提供Facebook/Google/Tiktok开户服务" },
      { title: "定制海外营销解决方案", details: "量身定制营销计划，付费/自然流量、私域流量、用户裂变有机组合" },
      { title: "全天候广告审核服务", details: "实时追踪、专业审核、避免违规、事故及时处理" },
      { title: "全程技术对接服务", details: "专业技术团队支持、专业的全链路解决方案" },
      { title: "资深跨境服务团队", details: "跨境电商行业十余年老牌团队，深谙成交逻辑" },
      { title: "数据支持服务", details: "专业团队产出市场分析数据，用数据决胜未来" },
      { title: "广告优化服务", details: "专业优化师团队在线引导，只为让您的每一分钱都花得更值" },
      { title: "广告创意服务", details: "提供广告创意支撑、广告素材制作及优化服务" },
    ],
  },
  featurePage: {
    title: "功能特性-Shoprise 官网",
    banner: "功能特性",
    vogueImagination: "VOGUE主题，满足您的想象力",
    vogueDesign: "VOGUE主题，精美的不止设计",
    tableHeaders: ["分类名称", "分类说明", "相关应用"],
    sections: [
      {
        title: "VOGUE主题",
        details: [
          { textHeader: "自带弹窗模块的主题，支持订阅表单和内容分离", textNormal: "既可以当订阅弹窗收集更多的顾客邮箱，还可以隐藏表单，作为网站弹窗通知展示给顾客。" },
          { textHeader: "支持图片、文字、链接自由搭配的品牌宣传模块", textNormal: "背景可以添加图片，内容也可以添加图片；按钮可以添加链接，文案也可以添加链接。" },
          { textHeader: "商品评论模块，支持展示店铺最新的商品评论", textNormal: "当店铺中有新的商品评论时会展示最新的商品评论，可点击查看并跳转到对应的商品详情页，进一步提高曝光量。" },
          { textHeader: "支持首页、列表页、详情页、结账页、产品卡片细致装修", textNormal: " 商品详情页独家支持宽屏和窄屏显示，用户可以根据自己商品的特点选择合适的选项，更完美地展现自己店铺。" },
          { textHeader: "个性化的图文、精选商品、视频等模块，满足各个行业需求", textNormal: " 图文模块除了一般的左右图文，还有多种个性混合布局模式，支持PC端和移动端单独配置图片，为您留下充足的想象空间。" },
          { textHeader: "", textNormal: "注重移动端体验，专业排版优化，支持banner等移动端单独配置；支持四个层级、图文并茂的导航；支持12个卡片20种排版模式；支持文字、图片、轮播、弹窗公告；融合社交元素，便捷分享、社交主页展示、Instagram帖子展示及相关商品推荐；丰富便捷的页脚编辑，支持添加菜单、图文、订阅、店铺信息；时尚鞋服、3C数码、家居、宠物、户外、汽配……精美模板一键使用，解放装修压力是为了更好地聚力于生意。" },
        ],
      },
      {
        title: "店铺搭建",
        details: [
          { textHeader: "多语言&多货币", textNormal: "支持10余种店铺语言，支持根据买家IP地址自动切换货币， 满足商品需要销往多个国家的需求，解决不同地区的销售政策差异化等问题；支持不同国家模板手工修改，支持卖家手动设置语言和货币， 针对不同国家/地区展示适应当地的装修风格、语言和货币， 并针对当地支付习惯进行收款，实现一店分身全球销售。" },
          { textHeader: "业内最强大的商品管理功能", textNormal: "一键导品，看上的东西再多也能一网打尽；一键搬迁，只需要动下手指，剩下的我们帮您完成；商品多维度检索，方便更好地组合营销；商品属性批量调整，解放您的大脑和时间。" },
          { textHeader: "最全面的属性设置", textNormal: "为您的产品提供不同的属性设置，例如多种尺码、颜色、材质等；每种属性都可以独立设置相关的价格、SKU、重量和库存。 " },
          { textHeader: "商品的分类管理", textNormal: "支持按类别、类型、季节、促销等条件整理商品；支持根据供应商、价格和库存自动对产品进行分类。 " },
          { textHeader: "商品展示多样化", textNormal: " 支持商品VR试穿，试穿好了再购买，有效降低退货概率；支持商品360°旋转展示，更好地呈现商品的全部细节；支持商品多图展示，打造精美的商品详情页。" },
          { textHeader: "商品SEO优化", textNormal: " 通过使用产品特定的SEO优化能力，对单件商品进行引流打造爆款。" },
        ],
      },
      {
        title: "店铺管理",
        details: [
          { textHeader: "顾客管理与顾客通知", textNormal: "支持顾客名单导入导出，快速录入新老客户；支持顾客按照条件筛选查找快速定位；支持下单、退单、发货、退货、退款、确认等全流程通知；通知模板多样化个性化设置。" },
          { textHeader: "店铺权限管理", textNormal: "全体应用可单独设置员工权限；快速定制员工岗位匹配权限；交叉权限自动解耦或关联启闭" },
          { textHeader: "订单系统", textNormal: "科学划分订单呈现结构，让值得关注的信息优先关注；支持查询订单、添加运单号、查看物流详情、更新物流状态等全流程操作。" },
          { textHeader: "多域名&店铺SEO", textNormal: " 支持一店多域名绑定；支持设置站点地图；店铺SEO结构化的资料优化、包括商品、店铺的SEO关键词、描述、关联性URL等优化。" },
        ],
      },
      {
        title: "转化利器",
        details: [
          { textHeader: "社交平台获取天然流量", textNormal: "支持Google Feed；支持Facebook Feed；支持Facebook Pixel 数据追踪；支持Google Analytics 数据追踪；支持Google Ads 数据追踪；支持TikTok Pixel 数据追踪；支持Hotjar 用户行为追踪；支持Lucky Orange 用户行为追踪。" },
          { textHeader: "结账流程优化", textNormal: "支持Google地址自动补全，减少顾客信息填写时长，加速结算流程；支持Paypal快捷支付，减少结账步骤；支持单页结账，优化结账环节减少页面跳转；结账页交互时间低至1s，保障结账效率，有效提升转化。" },
          { textHeader: "各类营销手段全面提升转化率 ", textNormal: "满减活动——刺激用户主动凑单提升销量；最近售卖弹窗——实时显示商品访客数、弹窗浮动显示最近被购买的商品，营造紧迫感，刺激下单；快捷加购——顾客可在下滑浏览的过程中便捷加购商品；优惠码——提供多种优惠码获取途径，提高优惠码使用率，诱导顾客消费；弹窗&公告栏——支持促销活动通知、邮件订阅通知、包邮通知、浮窗通知和邮件群发推荐商品——使其展示在其他商品的详情页中，以提高客单价和转化；组合销售——将不同的商品组合在一起进行销售，给予适当优惠，刺激用户凑单。 而我们的广告助手可以实时获取FB广告订单数据，呈现精准的广告投放数据，把握市场瞬态。" },
          { textHeader: "Facebook广告助手", textNormal: "由于隐私政策影响，Facebook官方助手只查看两到三天前的数据，严重影响运营人员对广告投放效果的判断。 而我们的广告助手可以实时获取FB广告订单数据，呈现精准的广告投放数据，把握市场瞬态。" },
        ],
      },
      {
        title: "移动端APP",
        details: [
          { textHeader: "数据查看", textNormal: "支持在APP上快速查看店铺运营数据，包括商品、客户、订单、营销等数据、并支持实时查看店铺访客和GMV信息。" },
          { textHeader: "库存管理", textNormal: "支持添加商品、下架商品、拍摄商品照片等对商品进行编辑的操作。" },
          { textHeader: "订单处理 ", textNormal: "支持在APP上查看订单详情，并对订单状态、付款状态、发货状态进行变更。" },
          { textHeader: "数据同步 ", textNormal: "当有用户新建订单、商品售罄的时候系统会将数据信息同步至移动端。" },
          { textHeader: "数据总览界面 ", textNormal: "基础指标有访问用户、订单量、成交额、转化率；转化漏斗有订单总成交额、订单转化率、访问用户数。" },
          { textHeader: "流量报告", textNormal: "通过流量报告，可以查看并得知访问者来源以及他们到店的方式。 " },
        ],
      },
      { title: "生态应用", details: [] },
    ],
    tableData: [
      { name: "商品管理", intro: "帮助运营管理店铺商品及商品销售渠道相关的应用", details: ["复制店铺", "谷歌Feed同步", "Facebook Feed", "自定义按钮", "Affiliatly"] },
      { name: "营销推广", intro: "通过邮件或其他方式的内容营销，以及广告及搜索引擎优化来提升店铺品牌的应用", details: ["Mailchimp", "Klaviyo", "营销弹窗", "智能营销", "谷歌Sitemap", "URL重定向", "Pixel Conversion"] },
      { name: "运营转化", intro: "激励客户进行购买，有助于提高转化率和客单价的应用", details: ["最近售卖弹窗", "分享激励", "访客计数器", "快捷加购", "组合商品", "EXTRA优惠码", "OptinMonster", "运费险", "推荐商品", "款式组合", "商品置顶", "促销倒计时"] },
      { name: "订单管理", intro: "帮助商家处理订单或方便告知客户订单状态的应用", details: ["马帮ERP", "斑马ERP", "Order Tracking"] },
      { name: "店铺设计", intro: "为客户店铺装修设计支持更多样式和功能的应用", details: ["商品规格调色板", "结账页信息栏", "商品评论", "第三方登录", "产品过滤器", "历史浏览记录", "产品卡片标签", "Instagram 展示", "尺码表"] },
      { name: "客户服务", intro: "方便商家为客户解决售前售后问题的应用", details: ["Tidio", "绑定 Messenger"] },
      { name: "店铺管理", intro: "协助维护店铺经营或店铺业务相关的技术工作的应用", details: ["地区访问限制", "自定义代码嵌入", "Shopify backup"] },
    ],
  },
  complaintsPage: {
    title: "投诉建议",
    subtitle: "Complaints & Suggestions",
    merchant: "我是商家",
    consumer: "我是消费者",
    trademark: "商标被侵权",
    copyright: "版权被侵权",
    complainMerchant: "投诉商家",
  },
  complaintForms: {
    replyNotice: "填写人需保证所填信息真实有效，Shoprise将在收到反馈后3-7个工作日以邮件形式回复您。",
    fileLimitError: "上传的文件不能超过10M",
    uploadFailed: "上传表单失败，",
    submitFailed: "提交表单失败,",
    name: "姓名",
    nameRequired: "请输入投诉人姓名",
    namePlaceholder: "请填写投诉人姓名",
    email: "邮箱",
    emailRequired: "请输入投诉联系人邮箱",
    emailInvalid: "请输入正确形式的邮箱",
    emailPlaceholder: "请填写投诉人联系邮箱，用于后续回复",
    phone: "电话",
    phoneRequired: "请输入投诉联系人电话",
    phoneInvalid: "请输入正确的手机号",
    phonePlaceholder: "请填写投诉人联系电话，用于后续回复",
    otherMaterial: "其他材料补充",
    otherMaterialRequired: "请上传其他材料",
    evidenceExtra: "上传能证明此网站侵权的材料证据（比如：图片，视频等，文件必须少于10MB）",
    added: "补充说明",
    addedPlaceholder: "可在此补充说明这些证据是如何证明该网站违规",
    submit: "提交",
    ok: "确定",
    successTitle: "提交成功",
    successMessage: "感谢您的反馈，我们会在审核资料后给您回复，请耐心等待。",
    repeatMessage: "您已经提交成功，无须再次提交",
    checkAll: "请勾选全部",
    declaration: "声明",
    declarations: [
      "本人本着诚信原则，此投诉内容未经版权所有者或其法定授权代理者授权。",
      "本人在伪证罪下宣誓，此投诉中的信息准确无误，并且本人是版权所有者或被法定授权代理者。",
      "本人确认，可以将此投诉的副本（包括上面提供的任何联系信息）提供给被投诉人。",
    ],
    consumer: {
      title: "消费者投诉登记表",
      shopUrl: "投诉的店铺地址",
      shopUrlRequired: "请输入投诉的店铺地址",
      shopUrlInvalid: "请输入正确的店铺url地址",
      shopUrlPlaceholder: "请填写投诉的店铺地址",
      productUrl: "投诉作品/商品的链接",
      productUrlRequired: "请输入投诉作品/商品的链接",
      productUrlPlaceholder: "请填写投诉作品/商品的链接，可填写多个，每个地址换行",
    },
    copyright: {
      title: "商家版权投诉登记表",
      roleLabel: "请选择投诉角色",
      ownerRole: "我是版权的拥有者",
      agentRole: "我是版权所有者的授权代表",
      certificate: "版权证书/授权证书",
      certificateExtra: "请上传版权证书或者授权证书，如有多个可以直接上传压缩包(文件大小不能大于10M)",
      copyrightUrl: "版权作品/商品的链接",
      copyrightUrlRequired: "请输入版权作品/商品的链接",
      copyrightUrlPlaceholder: "请填写版权作品/商品的链接，可填写多个，每个地址换行",
      infringementShop: "侵权的店铺地址",
      infringementShopRequired: "请输入侵权的店铺地址",
      infringementShopInvalid: "请输入正确的侵权店铺的url地址",
      infringementShopPlaceholder: "请填写侵权的店铺地址",
      infringementUrl: "侵权作品/商品的链接",
      infringementUrlRequired: "请输入侵权作品/商品的链接",
      infringementUrlPlaceholder: "请填写侵权作品/商品的链接，可填写多个，每个地址换行",
    },
    trademark: {
      title: "商家商标投诉登记表",
      ownerRole: "我是商标的拥有者",
      agentRole: "我是商标所有者的授权代表",
      companyName: "个人 / 公司名",
      companyNameRequired: "请填写个人 / 公司名",
      companyNameInvalid: "请输入长度为1-50个字符的个人/公司名",
      companyNamePlaceholder: "请填写个人 / 公司名",
      trademarkName: "商标名称",
      trademarkNameRequired: "请输入商标名称",
      trademarkNameInvalid: "请输入长度为1-50的商标名称",
      trademarkNamePlaceholder: "请填写商标名称",
      registrationPlace: "商标注册地",
      registrationPlaceRequired: "请输入商标注册地",
      registrationPlaceInvalid: "请输入长度为1-100个字符的商标注册地",
      registrationPlacePlaceholder: "请填写商标注册的国家地区",
      registrationNumber: "商标注册号",
      registrationNumberRequired: "请输入商标注册号",
      registrationNumberInvalid: "请输入长度为7-20个字符的注册号",
      registrationNumberPlaceholder: "请填写您的商标注册号",
      registrationService: "商标注册涵盖的产品/服务",
      registrationServiceRequired: "请输入商标注册涵盖的产品/服务",
      registrationServiceInvalid: "描述服务内容字数限制为100字",
      registrationServicePlaceholder: "请填写您的商标注册类型涵盖的产品/服务",
      infringementShopInvalid: "请输入正确的url地址",
    },
  },
  agreementPage: {
    title: "用户协议-Shoprise 官网",
    banner: "用户协议",
    header:
      "Shoprise是一个为商家提供工具和技术，帮助他们建立自己的网上商店并在网站上销售产品和服务的商业平台。我们相信自由开放和交流是商业的一个关键原则，但是有一些活动与Shoprise的使命—创造更好的电商服务是不相容的。本《使用协议》描述了一些您使用我们服务时被禁止的活动。下文所讲的“材料”是指您的账户上传、收集、生成、存储、显示、发布、传输、展示或与您账户有关的任何照片、图像、视频、图形、书面内容、音频文件、代码、信息或数据。",
    prohibited: "以下活动是禁止的：",
    sections: [
      { title: "1.儿童剥削：", detail: "您不得提供与非法利用或滥用儿童权益相关的商品和服务，也不得发布、上传任何此类材料，包括但不限于虐待儿童或性虐待，或者以性方式展示、介绍儿童的图片或描述。" },
      { title: "2.骚扰、欺凌、诽谤和威胁：", detail: "您不得提供骚扰、欺凌、诽谤或威胁特定个人的商品或服务，也不得发布、上传此类材料。" },
      { title: "3.恶意内容：", detail: "您不得通过使用我们的服务宣传或纵容针对种族、民族、肤色、国籍、宗教信仰、年龄、性别、性取向、残疾、健康状况或退伍军人身份进行的歧视和仇恨行为，也不得发布上传此类材料。您不得使用我们的服务来纵容或支持任何组织，平台或个人：（i）宣传或纵容此类仇恨； 或（ii）进一步宣传此类威胁或纵容此类暴力。" },
      { title: "4.非法活动：", detail: "您不得提供、发布或上传任何促成或宣传您所在司法管辖区的违法行为的商品或服务。" },
      { title: "5.知识产权：", detail: "您不得提供侵犯他人版权、商标权或其他知识产权的商品或服务，也不得发布上传此类材料。" },
      { title: "6.恶意和欺骗性的做法：", detail: "您不得使用Shoprise服务传播恶意软件或主机网络钓鱼页面。您不得进行损害或破坏Shoprise服务运营或其他Shoprise基础设施包括Shoprise第三方合作者的活动，也不得上传发布此类材料。您不得将本服务用于欺骗性的商业行为或其他任何非法或欺骗性行为。" },
      { title: "7.个人和机密信息：", detail: "您不得发布或上传任何包含个人身份信息，个人敏感信息或保密信息（如信用卡号码、保密国家身份证件号或账户密码）的材料，除非您已获得该信息所属权人的同意，或被授权提供该信息。" },
      { title: "8.自身伤害：", detail: "您不得提供或宣传与自我伤害相关的商品或服务，也不得发布上传此类材料。" },
      { title: "9.滥发邮件：", detail: "您不得使用本服务传输任何未经用户许可的商业电子信息。" },
      {
        title: "10.恐怖主义组织",
        detail:
          "您不得提供暗示、宣传或资助恐怖主义活动的商品或服务，也不得发布上传此类材料，或成为任何恐怖主义组织的成员。 如果您从事的活动违反了本《使用协议》（包括您在使用Shoprise服务之外的活动），我们有权随时删除任何材料，暂停或终止您的账户和您对我们服务的访问。 Shoprise有权随时监督或调查您使用的材料和Shoprise服务是否遵守本《使用协议》和Shoprise《 服务条款》，或任何其他与Shoprise达成的共识或协议（统称“协议”）。我们关于是否发生违反本《使用协议》行为的决定将是最终的和具有约束力的，我们自行决定如何处理违反本协议的行为（包括不采取任何行动）Shoprise若因Shoprise用户违反协议（“违约用户”）而致使Shoprise承担第三方赔偿责任的，Shoprise保留随时向违约用户追索赔偿补偿的权利；同时Shoprise保留要求该违约用户承担因此对Shoprise商誉损害的赔偿责任。 为给您提供更好的服务以及随着Shoprise业务的发展，本使用协议也会随之更新。《使用协议》修订版在生效前会发布公告或以其他适当方式提醒您相关内容的更新，也请您访问Shoprise网站以便及时了解最新的使用协议条款。 如果《使用协议》和《服务条款》发生冲突，以《使用协议》为准，但仅限于解决此类冲突所需的程度。在本协议中使用但未定义的术语应该按其所在协议中的含义定义。",
        date: ["最近更新日期：2021年05月31日", "生效日期：2021年05月31日"],
      },
    ],
  },
  termsPage: {
  "title": "服务条款-Shoprise 官网",
  "banner": "服务条款",
  "introLabel": "说明",
  "sections": [
    {
      "title": "1.账户条款",
      "details": [
        "1. 您必须年满18周岁或至少达到在您居住或使用本服务的法定年龄。",
        "2. 您必须取得您居住地或使用本服务所在地的合法经营者资质，包括但不限于已取得营业执照和完成相关税务登记，保证遵守您当地的合法经营性质。 ",
        "3. 要访问和使用该服务，您必须提供您的完整姓名，现住址，电话号码，有效的电子邮件地址，以及我们所需要的其他信息，且确保信息的真实性，否则我们有权利拒绝您的服务申请或随时终止对您的服务。",
        "4. 您同意将使用您提供的电子邮件地址作为主要沟通方式。 ",
        "5. 您有责任确保您的账户密码安全。如果您未能保持帐户和密码的安全性，Shoprise不会对任何损失或损害承担责任。 ",
        "6. 您需要对您账户上的活动负责，包括但不限于：上传，收集，生成，存储，显示，分发，传输或展示的材料（包括图像、照片、图形、音频、视频、书写内容、代码、信息或数据） 。",
        "7. 违反本条款中的任何条款，我们有权单方面终止协议停止对您的服务。 "
      ],
      "intro": [
        "您对自己的帐户以及上传到Shoprise的所有材料负责。请注意，如果违反这些条款，我们将取消您的服务。 ",
        "如果我们需要联系您，我们会向您发送电子邮件。"
      ]
    },
    {
      "title": "2.账户激活",
      "details": [
        "2.1 Shoprise账户 ",
        "1. 根据第2.1.2节的规定，本条款的目的，注册服务的人是账户所有者，并且将被授权使用我们提供给账户所有者的相关服务。",
        "2. 如果您代表您的雇主注册服务，则您的雇主应为账户所有者。如果您代表您的雇主注册服务，则您声明并保证您的雇主受此《Shoprise服务条款》的约束。"
      ],
      "anotherDetails": [
        "2.2 Checkout账户 ",
        "1. 我们已与多家收款渠道公司合作。您可以在Shoprise后台设置页面里选择收款方式，根据顾客的支付需求选择并设置其他种类的收款渠道。",
        "2. 为了避免歧义，收款渠道属于第三方服务，在本条款的第11条有定义。"
      ]
    },
    {
      "title": "3.通用条款",
      "details": [
        " 1. 在您成为Shoprise会员前，您必须阅读、同意并且接受本服务条款中包含的所有条款和条件，包括《Shoprise使用协议》和《隐私政策》。",
        "2. 服务条款适用于中华人民共和国法律，并按照中华人民共和国法律解释，不考虑法律冲突的原则。双方确认任何因本条款引发的争议或索赔均由中华人民共和国浙江省杭州市有管辖权的法院管辖。 ",
        "3. 您承认并同意Shoprise可随时通过在Shoprise网站上发布相关修订和重述的服务条款来修改本条款，条款的此类修订服务自发布之日起生效。在修订后的服务条款发布到Shoprise的网站后，您继续使用服务即表示您同意并接受修订后的服务条款。如果您不同意对服务条款进行任何更改，请不要继续使用本服务。 ",
        "4. 您不得将Shoprise服务用于任何非法或未经授权的目的，也不得在使用本服务时违反您所在司法辖区的任何法律（包括但不限于版权法），适用于您客户所在司法辖区的法律，或者中国的法律。您将遵守使用本服务时的所有适用法律法规。 ",
        "5. 您不得购买Shoprise、Shoprise商标以及其变体或错误拼写的域名和搜索引擎或其他点击付费关键词。",
        "6. 未经Shoprise书面许可，您不得翻版、复制、拷贝、出售、转售或为未授权第三方通过本服务的任何部分获利（包括但不限于本服务的使用以及访问）。 ",
        "7. 有关服务条款的问题应发送至 service@shoprise.com。 ",
        "8. 您知晓您的资料（不包括信用卡信息）可能未经加密转移，并涉及（a）通过各种网络传输；（b）为符合和适应连接网络或设备技术要求作出的改变。信用卡信息在网络传输过程中始终是加密的。",
        "9. 你认可并同意，您在使用本服务中涉及的信息，包括传送给Shoprise或者由Shoprise存储的信息，均受《隐私政策》的保护和约束。 ",
        "10. 本条款可能会有除中文以外的其他版本。如果不同语言版本的服务条款之间存在任何矛盾或冲突，以最新的中文版《Shoprise服务条款》为准。 ",
        "11.《Shoprise服务条款》的所有条款和规定对《Shoprise服务条款》双方及其各自的继承人、继任者、获准受让人和法定代表人具有约束力，并对其有利。Shoprise有权在不通知您或未经您同意的情况下转让这些服务条款。未经Shoprise事先书面同意，您无权将本服务条款或您的本协议下的任何权利或义务转让或以其他方式转让给第三方。 "
      ],
      "intro": [
        "您不得将Shoprise的服务用于任何非法目的。 ",
        "如果存在争议，将在中国浙江省杭州市有管辖权的法院处理。 ",
        "您的资料转移的时候未经加密，可能会被更改，但信用卡的信息是始终加密的。"
      ]
    },
    {
      "title": "4.Shoprise权利",
      "details": [
        "1. 我们保留以任何理由修改或终止服务的权利，恕不另行通知。",
        "2. 我们保留随时以任何理由拒绝向任何人提供服务的权利。",
        "3. 如果我们发现店铺提供的商品或服务或者发布到店铺的资料违反了Shoprise的《Shoprise使用协议》，我们将会移除资料并暂停或终止其账户。 ",
        "4. Shoprise不会预先筛选资料，我们可以自行决定拒绝或删除服务中的任何资料。",
        "5. 我们保留向您的竞争对手提供服务的权利，并且不承诺在任何特定细分市场中享有独家经营权。您进一步认可并且同意Shoprise合作商也可能是Shoprise的客户或商家，并且他们可能会与您竞争。",
        "6. 如果有关帐户所有权的争议，我们保留要求提供文件以确定或确认帐户所有权的权利。文件可能包括但不限于您的营业执照扫描件，政府签发的带照片的身份证件，信用卡的最后四位数字等。 ",
        "7. 我们有权判定合法账户的所有权，并有权将账户转让给合法的账户所有者。如果我们无法判定账户合法所有者，Shoprise将保留暂时禁用此账户的权利，直至争端双方确定解决方案为止。 "
      ],
      "intro": [
        "我们可以随时修改，取消或拒绝服务。",
        "如果发生Shoprise账户的所有权纠纷，我们可以冻结账户或将其转让给合法所有者。"
      ]
    },
    {
      "title": "5.责任限制",
      "details": [
        "1. 您明确理解并同意，Shoprise不承担任何因为使用或无法使用该服务导致的直接、间接、偶然的、特殊的、从属性的或惩罚性的损失，包括但不限于因使用或无法使用该服务带来的收益、商誉、数据或其他无形的损失。 ",
        "2. 在任何情况下，Shoprise不承担与我们的网站、服务或本《Shoprise服务条款》（包括因为过失引起的）有关所产生的利润损失或任何特殊的、偶然的或附属性的损失。您应确保Shoprise公司、Shoprise的高级职员、董事、代理人、员工和供应商免于因为您违反本《Shoprise服务条款》或其他附属文件（包括《Shoprise使用协议》），或您违反任何法律或第三方的权利而被起诉带来的赔偿要求，并同意赔偿我们已支付的相关诉讼费和损害赔偿，包括合理的律师费。 ",
        "3. 您自行承担使用本服务的风险。本服务以“现状”和“可用”为基础提供，不附带任何明示，暗示或法定的保证或条件。",
        "4. Shoprise不保证服务不会中断，及时，安全或无错误。",
        "5. Shoprise不保证使用本服务可能获得的结果是准确可靠的。 ",
        "6. Shoprise不保证您通过本服务购买或获得的任何产品，服务，信息或其他材料的质量符合您的期望，或者本服务中的任何错误都将得到纠正。 "
      ],
      "intro": [
        "如果您违反法律，违反本条款或第三方的权利，或者是您被起诉，我们概不负责。 ",
        "服务以“现状”提供给您，可能会有错误或者中断，我们不提供任何担保。"
      ]
    },
    {
      "title": "6.放弃和完成协议",
      "details": [
        "Shoprise未能行使或执行服务条款的任何权利或规定，并不视为对此类权利或规定的放弃。服务条款及其通过引用合并的文件构成您与Shoprise之间的完整协议，并管辖您对本服务的使用，取代您与Shoprise之间的任何先前协议（包括但不限于任何之前版本的条款、服务）。 "
      ],
      "intro": [
        "如果Shoprise任何时候没有执行任何这些条款，并不意味着Shoprise会放弃该权利。所有服务条款构成适用于您的协议。如果您与Shoprise之间的任何协议与这些条款冲突，则以本条款为主。"
      ]
    },
    {
      "title": "7.知识产权和客户内容",
      "details": [
        "1. 您保留您提供给Shoprise服务的所有资料的知识产权。您上传的所有资料都是您的。您可以随时删除您的账户以删除您的Shoprise店铺。 ",
        "2. 在上传资料时，您同意：（a）允许其他互联网用户查看您公开发布到您店铺的资料；（b）允许Shoprise存储，展示您的资料（对于您公开发布的资料）；（c）Shoprise可以在任何时候检查提交给其服务的任何资料，但Shoprise没有义务一定这样做。 ",
        "3. 您保留您上传到Shoprise店铺的所有资料的所有权；但是，为了让您的店铺公开，您同意并允许其他人查看您公开发布到店铺的资料。您有责任保证这些资料遵守任何适用的法律或法规。 ",
        "4. 我们不会将您的保密信息透露给第三方，除非我们在提供服务的过程中有此要求。保密信息包括您向我们提供的任何未公开的资料或信息。保密信息不包括：(a)在我们收到该信息时就已经公开的信息；（b）在我们收到该信息之后被公开（但不是由于我们的原因被公开）；（c）在不违反我们或其保密义务的情况下，我们从除你之外的其他人收到的信息；或者（d）法律要求我们披露的信息。 ",
        "5. Shoprise拥有使用与您店铺相关的名称、注册商标、服务标志和品牌徽标去营销Shoprise服务的非排他性的权利和许可。 "
      ],
      "intro": [
        " 您上传的任何东西都是您的，您需要对这些东西负所有责任。"
      ]
    },
    {
      "title": "8.主题商店",
      "details": [
        "1. 您可以通过装饰并使用Shoprise主题商店里的设计模板建立您自己的Shoprise店铺。您可以选择添加主题商店里的模板到您的店铺。 ",
        "2. 您可以选择修改主题以适合您的店铺。Shoprise可以酌情添加或修改用于引用Shoprise的页脚。Shoprise也可以自行决定修改其中违反《Shoprise使用协议》或《Shoprise服务条款》的内容。Shoprise可以根据需要修改主题以反映技术更改和更新。 ",
        "3. 主题的知识产权是属于设计师的。如果您超出购买主题所授予的权利，设计师可能会对您采取法律行动，Shoprise可能会采取行政措施，例如修改您的商店或关闭您的商店。 ",
        "4. 确保安装的新模板不会覆盖或者破坏用户当前或预存的主题或用户界面是用户的责任，Shoprise不承担任何的损失或损害。 "
      ],
      "intro": [
        " 您可以选择添加模板到您的Shoprise店铺。您可以随意修改装饰主题以适用您的店铺，但必须尊重模板所有者的权利。请注意，随着时间推移，主题可能会被更新修改或者消失。"
      ]
    },
    {
      "title": "9.取消和终止",
      "details": [
        "1. 您可以随时通过发送电子邮件至service@shoprise.com取消您的帐户， 然后按照Shoprise的回复中向您指示的具体说明进行操作。 ",
        "2. 任何一方因任何原因终止服务时： ",
        "• Shoprise将停止向您提供服务，您将无法再访问您的帐户; ",
        "• 除非服务条款另有规定，否则您无权要求退还或按比例退还任何费用; ",
        "• 在终止生效之日，您因使用Shoprise服务而欠的任何未结余额将立即到期且您须立即全额支付; ",
        "• 您的商店网站将脱机。",
        "3. 当您的店铺存在未结算费用时，Shoprise有权暂停您店铺在Shoprise上的部分或全部权限和功能；若您在30天内仍未完成结算的，Shoprise将立即清除您店铺的所有数据并终止向您提供服务。 ",
        "4. 我们保留以任何理由修改或终止Shoprise服务或您的帐户的权利，恕不另行通知; ",
        "5. 欺诈：如果我们怀疑您涉嫌任何欺诈行为，Shoprise将会暂停或终止您的账户。 "
      ],
      "intro": [
        "如果要终止账号，请发邮件到service@shoprise.com。Shoprise将回复您终止账户的具体步骤。 ",
        "我们可能随时修改或取消您的账户。如果您涉嫌任何欺诈，我们将暂停或终止您的账户。"
      ]
    },
    {
      "title": "10.服务和价格的修改",
      "details": [
        "1. Shoprise保留随时修改或终止本服务（或其中任何部分）的权利，恕不另行通知。 ",
        "2. Shoprise保留在通知或不通知的情况下随时修改或终止服务（或其任何部分）的权利。 ",
        "3. Shoprise不对您或任何第三方因为本服务的任何修改、价格变更、暂停或中断负责。 "
      ],
      "intro": [
        " 我们可以随时更改或终止服务，不承担任何责任。"
      ]
    },
    {
      "title": "11.第三方服务",
      "details": [
        "1. 除了这些服务条款之外，您同意并遵守适用于您购买或由第三方提供的服务的附加服务特定条款。 ",
        "2. Shoprise可能会不时推荐，为您提供访问或启用第三方软件，应用程序，产品，服务或网站链接（统称为“第三方服务”）供您考虑或使用，包括通过Shoprise应用或主页。此类第三方服务仅为方便起见而提供您购买，访问或使用任何此类第三方服务仅限于您与适用的第三方服务提供商（“第三方服务提供商”）之间。除了这些服务条款之外，您还同意受适用于您从第三方供应商处购买或由第三方供应商提供的服务的其他服务特定条款的约束。 ",
        "3. 我们不提供有关第三方服务的任何保证。您认可Shoprise无法控制第三方服务，因此对使用此类第三方服务的任何人不承担任何责任。Shoprise不保证第三方服务的可用性，您认可Shoprise可能随时自行决定禁止访问任何第三方服务，且无需通知您。Shoprise不会因为暂停访问或禁用某第三方服务对任何人承担任何责任。 ",
        "4. 如果您在使用本服务时安装或启用了第三方服务，则您授权允许适用的第三方提供商访问您的数据、采取必要的用于与第三方和本服务之间的交互操作。任何您与第三方提供商之间的数据交换和其他交互仅限于您与此类第三方供应商之间。由于第三方服务和第三方提供商可以对您的数据和其他资料进行访问，Shoprise对于您的数据或其他资料的披露、修改或删除，或者您可能遭受的任何相应的损失或损害不承担任何责任。 ",
        "5. 在任何情况下，Shoprise均不对由于任何第三方服务或您与第三方提供商之间的合作关系所造成的任何直接、间接、偶然、特殊、惩罚性、或其他损害负责。上述限制应在适用法律允许的最大范围内适用。 ",
        "6. 您与任何第三方提供商之间的关系严格限制在您与此类第三方提供商之间，Shoprise没有义务介入您与第三方提供商之间发生的任何争议。 ",
        "7. 您同意赔偿并使我们和（如适用）我们的母公司，子公司，关联公司，Shoprise合作伙伴，管理人员，董事，代理人，员工和供应商免于因您的使用而产生的任何索赔或要求，包括合理的律师费第三方服务或您与第三方提供商的关系。 "
      ],
      "intro": [
        "我们不对第三方服务负责，因此使用它们需要您自担风险。如果您在Shoprise平台上使用任何第三方服务，则允许我们将您的数据发送到这些服务。如果您使用它们，您同意我们不提供服务保障，因此请事先咨询我们。"
      ]
    },
    {
      "title": "12.测试服务",
      "details": [
        "1. Shoprise可能会不时自行决定邀请您在试用版中使用正在开发但尚未向所有商家提供的预发布或测试版功能。 ",
        "2. 测试服务可能受其他条款和条件的约束，Shoprise将在您使用测试服务之前向您提供这些条款和条件。 ",
        "3. 此类测试服务以及与之相关的所有相关对话和材料将被视为Shoprise机密信息，并受本协议中的保密规定的约束。 ",
        "4. 在不限制前述内容的一般性的前提下，您同意未经Shoprise事先书面同意，您不能发表任何公开声明或以其他方式披露您参与测试服务。 ",
        "5. Shoprise不对测试服务的运作作出任何陈述或保证。Shoprise可自行决定随时终止测试服务。对于因测试服务引起的或与之相关的任何伤害或损害，Shoprise概不负责。 ",
        "6. 测试服务可能与最终版本的工作方式不同。Shoprise可以自行决定是否更改或不发布测试服务的最终版本或商业版本。"
      ]
    },
    {
      "title": "13.保密义务",
      "details": [
        "  在您使用Shoprise服务的期间，您可能会获取到与Shoprise公司和/或Shoprise服务相关的但并未向公众披露的信息（“Shoprise保密信息”）。您同意：（a）Shoprise对Shoprise保密信息拥有专属权；（b）您不会讲Shoprise保密信息披露于任何第三方，除了向您关联方、雇员、承包商或代理 （“关联方”），此关联方同时受此保密义务和本条款的约束和限制；以及（c）您将通过所有合理措施确保Shoprise保密信息不在本条款允许范围外被披露。       "
      ],
      "intro": [
        "如果您收到Shoprise机密信息，则需要对其进行保护。 "
      ]
    },
    {
      "title": "14.隐私和数据保护",
      "details": [
        "Shoprise非常重视对您和您用户的个人信息的隐私保护（“个人信息”）。通过使用Shoprise服务，您认可并同意Shoprise在收集、使用和披露这些个人信息时遵守《隐私政策》的约定。 "
      ],
      "intro": [
        " Shoprise对个人信息的收集和使用将遵守《隐私政策》的约定。"
      ]
    },
    {
      "title": "15.意见反馈",
      "details": [
        "Shoprise欢迎任何有关改进或增补服务的想法或建议。在任何情况下，您披露的任何想法、建议或相关材料，对服务、第三方服务或第三方服务商的评价（统称“反馈”）都不是保密信息或您也没有获得赔偿的预期。通过向Shoprise提供反馈 （无论是直接提交给Shoprise还是任何Shoprise主办的论坛或拥有的页面上发布），您放弃反馈中所有的权利，并且Shoprise有权可以在未经您或任何第三方的许可的情况下根据需要自由实施和使用您所提供的反馈。您提交给Shoprise的针对第三方服务或第三方服务商的任何评论必须是您所知最准确的，并且不得是违法的，淫秽的，威胁的，诽谤的，侵犯隐私的，侵犯知识产权的，或以其他方式伤害第三方或令人反感的。Shoprise保留删除、编辑第三方服务或第三方服务商反馈的权利（但没有义务），Shoprise没有定期检查发布的反馈的义务。"
      ],
      "date": [
        "最近更新日期：2021年05月31日",
        "生效日期：2021年05月31日"
      ]
    }
  ]
},
  privacyPage: {
    title: "隐私政策-Shoprise 官网",
    banner: "隐私政策",
    introLabel: "说明",
    sections: [
      { title: "1.介绍", details: ["欢迎使用Shoprise！", "Shoprise重视用户隐私。我们会说明在您使用产品或服务时如何收集、使用、保存、共享和转让相关信息。", "您使用我们的服务或与使用我们服务的商家交易，即表示同意本《隐私政策》和相关服务条款。", "我们会根据运营、法律或合规需求不定时修订本政策，并在重大变化时以适当方式通知您。"] },
      { title: "2.收集来自商家的信息", details: ["作为商家，您同意在店铺网站首页发布符合法律法规要求的隐私政策。", "我们会收集您的姓名、公司名称、地址、电子邮件地址、电话号码和支付相关信息，用于提供服务、处理订单、验证付款并改善服务。", "我们还会收集您访问Shoprise托管网页和账户的方式、时间、设备、浏览器、网络连接和IP地址等数据。"] },
      { title: "3.收集来自商家顾客的信息", details: ["我们可能收集商家顾客的姓名、电子邮件地址、物流配送和账单地址、支付资料、公司名称、电话号码、IP地址和设备数据。", "这些信息用于为商家提供服务，包括支付、处理订单、验证付款并改善服务。"] },
      { title: "4.收集来自一键迁移用户的信息", details: ["我们会根据您选择迁移的模块收集店铺迁移所需的信息，可能包括商品信息、博客信息或顾客信息。", "这些信息用于完成从其他店铺到Shoprise店铺的一键导入。"] },
      { title: "5.收集来自Shoprise网站浏览、咨询客户的信息", details: ["对于Shoprise网站访问者，我们会收集设备、浏览器、网络和IP地址信息。", "对于邮件或电话咨询客户，我们可能收集姓名、邮箱、电话号码、设备、浏览器、网络、IP地址和通信记录等信息。"] },
      { title: "6.信息共享", details: ["除获得您明确同意、法律法规要求、保护合法权益、实现服务核心功能或处理争议等必要情形外，我们不会与Shoprise以外的公司、组织和个人共享您的个人信息。"] },
      { title: "7.基于符合法律法规的社会公共利益而使用", details: ["我们可能与关联方、合作伙伴或服务供应商共享必要个人信息，但仅限合法、正当、必要、特定、明确的目的。", "我们会要求共享方按照本隐私政策和保密安全措施处理个人信息。", "在法律法规规定的特定情形下，我们收集、使用个人信息可能无需征得授权同意。"] },
      { title: "8.注销账户", details: ["您可以在我们的产品中申请注销账户。账户注销后，我们将停止提供产品或服务，并依法处理或删除您的个人信息。", "为合法商业目的并遵守法律法规，我们可能继续保存相关交易记录和匿名化信息。"] },
      { title: "9.信息安全", details: ["我们会采取合理安全措施保护个人信息，防止未经授权访问、披露、使用、修改、损坏或丢失。", "互联网环境并非绝对安全，我们将尽力保障您发送给我们的信息安全。"] },
      { title: "10.未成年人信息保护", details: ["我们重视未成年人个人信息保护。如果您是未成年人，请在监护人指导下使用我们的服务并提交个人信息。"] },
      { title: "11.隐私政策更新", details: ["为提供更好的服务并随着Shoprise业务发展，本隐私政策可能更新。未经您明确同意，我们不会削减您依据本政策享有的权利。", "对于重大变更，我们会提供更显著的通知。"] },
      { title: "本政策所指的重大变更包括但不限于：", details: ["1.我们的服务模式发生重大变化。", "2.我们在所有权结构、组织架构等方面发生重大变化。"], date: ["最近更新日期：2021年05月31日", "生效日期：2021年05月31日"] },
    ],
  },
  pricingPage: {
    title: "套餐定价-Shoprise 官网",
    cta: "开启30天免费使用",
    featureDetails: "功能细则",
    plans: ["基础版", "标准版", "旗舰版", "专享版"],
    monthlyRent: "月租",
    month: "/月",
    quote: "咨询报价",
    custom: "无界式定制",
    privateDeploy: "私人部署",
    transactionFee: "交易费用",
    targetSeller: "适用卖家",
    serviceSupport: "服务支撑",
    basicFeature: "独立站基础功能",
    sellers: ["个人用户", "中小卖家", "企业级卖家"],
    support: ["7*12h在线客服", "7*12h在线&电话客服", "7*24h客户成功团队支持"],
    transactionRates: ["交易费率2%", "交易费率1%", "交易费率0.6%"],
    featureGroups: [
      {
        title: "店铺管理",
        items: ["地区访问限制", "自定义代码嵌入", "Shopify backup"],
      },
      {
        title: "商品管理",
        items: ["谷歌Feed同步", "Facebook Feed", "自定义按钮", "Affiliatly"],
      },
      {
        title: "营销推广",
        items: [
          "Mailchimp",
          "Klaviyo",
          "营销弹窗",
          "谷歌Sitemap",
          "URL重定向",
          "智能营销",
          "Pixel Conversion",
        ],
      },
      {
        title: "运营转化",
        items: [
          "最近售卖弹窗",
          "分享激励",
          "访客计数器",
          "快捷加购",
          "EXTRA优惠码",
          "OptinMonster",
          "推荐商品",
          "款式组合",
          "促销倒计时",
          "组合商品",
          "运费险",
          "商品置顶",
        ],
      },
      {
        title: "订单管理",
        items: ["马帮ERP", "斑马ERP", "Order Tracking"],
      },
      {
        title: "店铺设计",
        items: [
          "商品规格调色板",
          "结账页信息栏",
          "商品评论",
          "第三方登录",
          "历史浏览记录",
          "产品卡片标签",
          "尺码表",
          "Instagram 展示",
          "产品过滤器",
        ],
      },
      {
        title: "客户服务",
        items: ["Tidio", "绑定 Messenger"],
      },
    ],
  },
};

export default zhCN;
